<div class="megamenu">
  <div
    class="justify-start megamenu__option-label megamenu-header bg-transparent text-white"

    (click)="categoriesClick(categoryId)"
  >
    {{ categoryName }}
  </div>

  <div class="megamenu__option-children menu-category first-dropdown">
    <div
      class="megamenu__option"
      *ngFor="let item of categories; last as isLast; let i = index"
    >
      <div
        class="megamenu__option-label menu-list"
        [ngClass]="{ 'mb-0': isLast }"
        *ngIf="i < 12"
      >
        <span (click)="categoriesClick(item?.id)">
<!--          <img-->
<!--            alt="No Image"-->
<!--            class="mr-10"-->
<!--            style="max-width: 20px; display: inline-block"-->
<!--            onerror="this.onerror=null;this.src='assets/images/placeholder.png'"-->
<!--          />-->

          {{ item.categoryName }}
        </span>
        <mat-icon
          *ngIf="item && item.categories && item.categories.length > 0"
          class="arrow-icon"
          >keyboard_arrow_right
        </mat-icon>
      </div>
      <div class="megamenu__option-children menu-otions-list megamenu-scroll-add">
        <span
          *ngIf="item && item.categories && item.categories.length > 0"
          class="categoriesHeading subCatHeading"
        >
          {{ item.categoryName }}</span
        >
        <div class="megamenu__option" *ngFor="let item1 of item.categories">
          <div class="ml-0 megamenu__option-label items-category">
            <span (click)="categoriesClick(item1?.id)">
              {{ item1.categoryName }}
            </span>
            <mat-icon
              *ngIf="item1 && item1.categories && item1.categories.length > 0"
              class="arrow-icon"
              >keyboard_arrow_right
            </mat-icon>
          </div>
          <div class="megamenu__option-children menu-otions-list">
            <span
              *ngIf="item1 && item1.categories && item1.categories.length > 0"
              class="categoriesHeading subCatHeading"
            >
              {{ item1.categoryName }}</span
            >
            <div
              class="megamenu__option"
              *ngFor="let item2 of item1.categories"
            >
              <div class="ml-0 megamenu__option-label items-category">
                <span (click)="categoriesClick(item2?.id)">
                  {{ item2.categoryName }}
                </span>
                <mat-icon
                  *ngIf="
                    item2 && item2.categories && item2.categories.length > 0
                  "
                  class="arrow-icon"
                  >keyboard_arrow_right
                </mat-icon>
              </div>
              <div class="megamenu__option-children menu-otions-list">
                <span
                  *ngIf="
                    item2 && item2.categories && item2.categories.length > 0
                  "
                  class="categoriesHeading subCatHeading"
                >
                  {{ item2.categoryName }}</span
                >
                <div
                  class="megamenu__option"
                  *ngFor="let item3 of item2.categories"
                >
                  <div class="ml-0 megamenu__option-label items-category">
                    <span (click)="categoriesClick(item3?.id)">
                      {{ item3.categoryName }}
                    </span>
                    <mat-icon
                      *ngIf="
                        item3 && item3.categories && item3.categories.length > 0
                      "
                      class="arrow-icon"
                      >keyboard_arrow_right
                    </mat-icon>
                  </div>
                  <div class="megamenu__option-children menu-otions-list">
                    <span
                      *ngIf="
                        item3 && item3.categories && item3.categories.length > 0
                      "
                      class="categoriesHeading subCatHeading"
                    >
                      {{ item2.categoryName }}</span
                    >
                    <div
                      class="megamenu__option"
                      *ngFor="let item4 of item3.categories"
                    >
                      <div class="ml-0 megamenu__option-label items-category">
                        <span (click)="categoriesClick(item4?.id)">
                          {{ item4.categoryName }}
                        </span>
                        <mat-icon
                          *ngIf="
                            item4 &&
                            item4.categories &&
                            item4.categories.length > 0
                          "
                          class="arrow-icon"
                          >keyboard_arrow_right
                        </mat-icon>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
